import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'dateConversion',
    pure: false,
    standalone: false
})
export class DateConversionPipe implements PipeTransform {

  constructor(public translate: TranslateService) { }

  transform(totalMonths: number | null | undefined): string {
    // Handle null/undefined cases
    if (totalMonths === null || totalMonths === undefined) {
      return '';
    }

    const months = Number(totalMonths);

    if (isNaN(months) || months < 0) {
      return '';
    }

    const years = Math.floor(months / 12);
    const remainingMonths = Math.floor(months % 12);

    let parts: string[] = [];

    if (years > 0) {
      const yearKey = years === 1 ? 'PIPES.DATE_YEARS.SINGULAR' : 'PIPES.DATE_YEARS.PLURAL';
      parts.push(this.translate.instant(yearKey).replace('{count}', years.toString()));
    }

    if (remainingMonths > 0) {
      const monthKey = remainingMonths === 1 ? 'PIPES.DATE_MONTHS.SINGULAR' : 'PIPES.DATE_MONTHS.PLURAL';
      parts.push(this.translate.instant(monthKey).replace('{count}', remainingMonths.toString()));
    }

    if (parts.length === 0) {
      const monthKey = 'PIPES.DATE_MONTHS.PLURAL';
      parts.push(this.translate.instant(monthKey).replace('{count}', '0'));
    }

    return parts.join(', ');
  }
}
